<template>
  <v-row :class="`content ${backgroundColor}`">
    <!-- sm and up -->
    <v-col
      cols="6"
      v-if="$vuetify.breakpoint.smAndUp"
    >
      <!-- sm only -->
      <div v-if="$vuetify.breakpoint.sm" class="app-image"></div>
    </v-col>

    <!-- This will show in all window sizes -->
    <v-col cols="12" sm="6" md="6" lg="6" xl="6">
      <v-container fill-height>
        <v-row
          align="center"
          :justify="$vuetify.breakpoint.xs ? 'center' : 'start'"
        >
          <div
            class="text"
            data-aos="fade-left"
          >
            <h1 :class="`${titleColor}--text`">{{ title }}</h1>
            <p :class="[ $vuetify.breakpoint.xs ? 'caption' : 'pre-wrap', `mt-3 ${captionColor}--text` ]">{{ caption }}</p>
          </div>
        </v-row>
      </v-container>
    </v-col>

    <!-- xs only -->
    <v-col
      cols="12"
      class="hidden-sm-and-up"
      v-if="MIXIN_SETUP_UI.show"
    >
      <v-row justify="center">
        <div class="text-center" data-aos="fade-up">
          <v-img
            src="@/assets/images/others/doc_juan.png"
            contain
            width="40vw"
            height="100%"
          ></v-img>
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "FeatureRow",
    props: {
      title: { type: String, default: '' },
      caption: { type: String, default: '' },
      backgroundColor: { type: String, default: '' },
      titleColor: { type: String, default: '' },
      captionColor: { type: String, default: '' }
    }
  }
</script>

<style lang="scss" scoped>
.content {
  height: 700px;
}
.text {
  width: 80%;
}

.app-image {
  height: 700px;
  background: url('~@/assets/images/others/doc_juan.png') center / 50% no-repeat;
}
</style>